// extracted by mini-css-extract-plugin
module.exports = {"switch":"SwitchQ_switch__24awL","checked":"SwitchQ_checked__3t2OP","thumb":"SwitchQ_thumb__1zeMi"};